import React from "react";
import styled from "styled-components";
import { WIZARD_STEP_LABELS } from "../../constants";

const Indicator = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 0;
	width: 100%;
	max-width: 64rem;
	margin-bottom: 2rem;
`;

const StepItem = styled.div`
	display: flex;
	align-items: center;
	max-width: 11rem;

	&:last-child {
		max-width: none;
	}
`;

const StepCircle = styled.div`
	width: 2rem;
	height: 2rem;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 0.875rem;
	font-weight: 600;
	flex-shrink: 0;
	background: ${(props) => (props.active || props.completed ? "rgba(45, 35, 66, 0.8)" : "#e5e5e5")};
	color: ${(props) => (props.active || props.completed ? "#fff" : "rgba(0, 0, 0, 0.5)")};
`;

const StepLabel = styled.span`
	margin-left: 0.5rem;
	font-size: 0.8rem;
	font-weight: ${(props) => (props.active ? 600 : 400)};
	color: ${(props) => (props.active ? "#36395a" : "rgba(0, 0, 0, 0.5)")};
	white-space: nowrap;

	@media (max-width: 700px) {
		display: none;
	}
`;

const Connector = styled.div`
	flex: 1;
	height: 2px;
	margin: 0 0.5rem;
	background: ${(props) => (props.completed ? "rgba(45, 35, 66, 0.8)" : "#e5e5e5")};
`;

const OfferStepIndicator = ({ currentStep }) => {
	const steps = Object.keys(WIZARD_STEP_LABELS).map(Number);

	return (
		<Indicator>
			{steps.map((step, index) => (
				<React.Fragment key={step}>
					<StepItem>
						<StepCircle active={currentStep === step} completed={currentStep > step}>
							{step}
						</StepCircle>
						<StepLabel active={currentStep === step}>
							{WIZARD_STEP_LABELS[step]}
						</StepLabel>
					</StepItem>
					{index < steps.length - 1 && (
						<Connector completed={currentStep > step} />
					)}
				</React.Fragment>
			))}
		</Indicator>
	);
};

export default OfferStepIndicator;
